import { useState, useEffect, useRef, useCallback } from 'react';
import Breadcrumbs from '@mui/material/Breadcrumbs';
import Stack from '@mui/material/Stack';
import NavigateNextIcon from '@mui/icons-material/NavigateNext';
import HomeIcon from '@mui/icons-material/Home';
import { useNavigate } from 'react-router-dom';

export const BreadcrumbContainer = ({ pathname, link }) => {
    const navigate = useNavigate();
    const previusLink = useRef(true);
    const pathMemory = useRef([]);
    const [maxList, setMaxList] = useState(4);

    //CALCOLO LARGHEZZA TOTALE WIDTH
    const [screenSize, getDimension] = useState(window.innerWidth);
    const setDimension = () => {
        getDimension(window.innerWidth);
    };

    const [pathTot, setPathTot] = useState([]);

    const handleClick = useCallback(
        (linkName, type, event) => {
            if (event) {
                if (
                    event.target.id ===
                    pathMemory.current[pathMemory.current.length - 1].props.id
                ) {
                    return;
                } else {
                    navigate(linkName);
                }
            } else {
                if (type === 'back') {
                    //se è una pagina dettaglio torno indietro
                    navigate(linkName);
                } else {
                    navigate(`${linkName}`);
                }
            }
        },
        [navigate]
    );

    useEffect(() => {
        window.addEventListener('resize', setDimension);

        return () => {
            window.removeEventListener('resize', setDimension);
            if (screenSize >= '900') {
                setMaxList(4);
            } else {
                setMaxList(2);
            }
        };
    }, [screenSize]);

    useEffect(() => {
        pathMemory.current = pathTot;
    }, [pathTot]);

    useEffect(() => {
        (() => {
            let pathHistory = [...pathMemory.current];
            //se eseguono un refresh forzo l'aggiunta di Home come primo elemento dell'array
            if (pathHistory.length === 0) {
                pathHistory.push(
                    <button
                        id="Home"
                        key={1}
                        color="inherit"
                        style={{
                            alignItems: 'center',
                            display: 'flex',
                        }}
                        className="text-underline-hover"
                        onClick={() => handleClick('/')}
                    >
                        <HomeIcon sx={{ mr: 0.5 }} fontSize="inherit" />
                        Home
                    </button>
                );
            }
            for (let i = 0; i < pathHistory.length; i++) {
                //se non è "dettaglio" elimino lo sotrico dopo Home
                if (!pathname.includes('dettaglio')) {
                    pathHistory = pathHistory.slice(0, 1);
                }
                //se esiste già nella Breadcrumb torno indietro e elimino lo storico
                if (pathHistory[i].props.id === pathname) {
                    pathHistory = pathHistory.slice(0, i + 1);
                    previusLink.current = false;
                }
            }
            if (previusLink.current) {
                if (pathname === 'Home') {
                    pathHistory.push(
                        <button
                            id={pathname}
                            key={pathHistory.length + 1}
                            color="inherit"
                            style={{
                                alignItems: 'center',
                                display: 'flex',
                            }}
                            className="text-underline-hover"
                            onClick={() => handleClick('/')}
                        >
                            <HomeIcon sx={{ mr: 0.5 }} fontSize="inherit" />
                            {pathname}
                        </button>
                    );
                } else if (pathname.includes('dettaglio')) {
                    pathHistory.push(
                        <button
                            id={pathname}
                            key={pathHistory.length + 1}
                            color="inherit"
                            className="text-underline-hover"
                            onClick={(e) => handleClick(-1, 'back', e)}
                        >
                            {link}
                        </button>
                    );
                } else if (pathname === '') {
                    return;
                } else {
                    pathHistory.push(
                        <button
                            id={pathname}
                            key={pathHistory.length + 1}
                            color="inherit"
                            className="text-underline-hover"
                            onClick={() => handleClick(pathname)}
                        >
                            {pathname.replace(/([A-Z])/g, ' $1').trim()}
                        </button>
                    );
                }
            }
            setPathTot(pathHistory);
            pathMemory.current = pathHistory;
            previusLink.current = true;
        })();
    }, [pathname, handleClick, link]); //tutte le volte che cambia il pathname viene eseguito
    return (
        <>
            <Stack spacing={2} marginLeft={2}>
                <Breadcrumbs
                    maxItems={maxList}
                    sx={{ overflow: 'hidden' }}
                    className="containerBreadcrumbs"
                    separator={<NavigateNextIcon fontSize="small" />}
                    aria-label="breadcrumb"
                >
                    {pathTot}
                </Breadcrumbs>
            </Stack>
        </>
    );
};
